import React, { PropTypes, PureComponent } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';

// import { H1 } from '../../../components/common/text';
import PaymentDashboard from './payment-dashboard';
import PaymentSelection from './payment-selection';
import Modal from '@dbk/ui-modal';
import Text,{H1} from '@dbk/ui-text';

import styles from './payments.styles';
import { PALETTE, ROUTES } from '../../../constants';
import BlurModal from '../../../components/common/blur-modal';
import Button from '@dbk/ui-buttons';
import PaymentFilter from '../init-payments/payment-filter/payment-filter';
import PaymentRefresh from '../init-payments/payment-refresh';
import PaymentError from '../payment-error';
import ErrorIcon from '../../../components/common/icons/error-icon';
class Payments extends PureComponent {
  state = {
    showFailModal: false,
    failMsg: '',
    filterClicked: false
  }
  componentWillUnmount() {
    this.toggleCreateModal(false)
    this.props.payments.setRemarks('');
    this.props.payments.setPaymentReason('');
  }

  toggleCreateModal = state => this.props.payments.setCreateNewModal(state)

  createNewPayment = () => {
    this.props.payments.resetForm();
    this.props.payments.refreshPayments();
    // this.props.payments.setPosId(psPosId);
    this.toggleCreateModal(true);
    this.props.payments.setBeneficiaryIdToUpdate(null);
    this.props.payments.setExistingBeneficiaryId(null);
  }

  componentDidMount() {
   // WMCE-31199 "new Payment " button missing
    const {
      payments: { resetVoPGlobals },
      app: { config: { isVopEnabled } },
    } = this.props;
   this.props.enablePaymentByPortfolioId();
   if(document.querySelector('.logo-web')){
      document.querySelector('.logo-web').focus();
    }
    isVopEnabled && resetVoPGlobals();
  }
  toggleFilter(){
   this.setState({filterClicked: true})
  }
  
  render() {
    const { i18n: { messages },
    auth: { isPaymentCheck, vascoActivated, passwordExpired, entitlement },
    payments: { errorMsgs,isPaymentEndpointFailed } } = this.props;

    if (isPaymentEndpointFailed) {
      let msg = (errorMsgs && errorMsgs[0].errorDesc) ? errorMsgs[0].errorDesc : messages['app.payments.failToConnect']
      
      return (
        <Modal
          isActive
          onClose={() => this.props.changePage(ROUTES.SUMMARY.DASHBOARD)}
          className={"model-window-login"}
          content={
            <div className="small-12 row padding-bottom-20 padding-top-10" >
              <div className="column small-2">
                <ErrorIcon width={30} height={30} />
              </div>
              <div className="column small-10" role="alert" tabIndex={0} aria-label={msg}>
                <Text secondary>{msg}</Text>
              </div>
            </div>
          }
        />
      )
    }

    return (
      <div className="payment-page row">
        {errorMsgs && <PaymentError errors={errorMsgs} aria-label={errorMsgs}/>}
        <div className="title-header" id="title_paymentsPage_index_test">
          <H1 className="title" tabIndex={0}>{messages['app.common.pageHeader.Payments']}</H1>
          {/* <h2 className="data-title">{messages['app.common.pageTitle.dataExports']}</h2> */}

              <span className={'filterIcon'} style={{display:'flex'}}>
                {entitlement.payment && !passwordExpired && isPaymentCheck &&  vascoActivated && (
                  <Button testID="btn_payments_createNew_index_test"
                    role="button"
                    id="focusButton"
                    size="large"
                    onPress={() => this.createNewPayment()}>
                    {messages['app.payments.newPayment']}
                  </Button>
                )}
              <PaymentRefresh/>
              </span>
              
        </div>
       
        <div className="paymentDash">
          <PaymentDashboard />
        </div>
        <div className="paymentSelection">
          <PaymentSelection />
        </div>
      </div>
    )
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    payments : {
      psPosId: true,
      errorMsgs: true,
      isPaymentEndpointFailed: true,
      setRemarks: { $set: 'remarks'},
      setPaymentReason: { $set: 'paymentReason'},
      setBeneficiaryIdToUpdate: { $set: 'beneficiaryIdToUpdate'},
      setExistingBeneficiaryId: { $set: 'existingBeneficiaryId' },
      setPosId: { $set: 'psPosId' },
      resetForm: { $call: 'resetForm' },
      refreshPayments: { $call: 'refreshPayments' },
      setCreateNewModal: { $set: 'createNewModal' },
      resetVoPGlobals: { $call: 'resetVoPGlobals' },
    },
    changePage: { $call: 'ui.history.push' },
    enablePaymentByPortfolioId : { $call: 'auth.enablePaymentByPortfolioId'},
    auth: {
      entitlement: true,
      passwordExpired: true,
      isPaymentCheck: true,
      vascoActivated: true,
    },
    app: {
      config: {
        isVopEnabled: true,
      }
    },
  },
})(Payments);

